import CrudController from "./crud_controller";
import { Controller } from "stimulus";

export default class extends Controller {


  connect() {
    this.siteNum = this.data.get("siteNum");
    this.devNum = this.data.get("devNum");
    //this.loadList();
  }

  loadList(params) {
    this.fetchForTarget(window.App.prefixedUrl(`/sites/${this.siteNum}/devices/${this.devNum}/configs`), this.listTarget)
      .finally(() => {
        this.hideLoading();
      });
  }

  handleDeleteResponse(event)
	{
		if (event.detail[0].success)
		{
			const createEvent = new CustomEvent("show-toast", { detail: "Configuration successfully deleted!" });
			window.dispatchEvent(createEvent);

			let section = event.target.closest(`.device-configs`);
			event.target.closest(".wrapper").remove();
			
			if(section.children.length == 0)
      {
        let div = document.createElement("div");
				div.innerHTML = ` <div class="text-muted">No Device Configurations found.</div>`;
				section.appendChild(div.firstElementChild);
      }
		}
		else
		{
			const errorEvent = new CustomEvent("show-toast", { detail: "An error occurred: \n" + event.detail[0].error });
			window.dispatchEvent(errorEvent);
		}
	}

  handleEditResponse(event) {
    let successMessage = event.target.dataset["message"];
    if(!successMessage) successMessage = "Success!";

    let toastEvent = null;

    if (event.detail[0].success) {
      toastEvent = new CustomEvent("show-toast", { detail: successMessage });

    } else {
      toastEvent = new CustomEvent("show-toast", { detail: "An error occurred:\n" + event.detail[0].error })
    }

    window.dispatchEvent(toastEvent);
  }

  edit(event) {
    let signalRuleNum = event.currentTarget.dataset.signalRuleNum;
    this.highlightRow(this.configRowTargets.indexOf(event.currentTarget));
    this.fetchForTarget(window.App.prefixedUrl(`/sites/${this.siteNum}/devices/${this.devNum}/configs/${signalRuleNum}/edit`),
      this.configTarget)
      .finally(() => {
        this.hideLoading();
      });
  }

  new(event) {
    this.clearMessage();
    this.fetchForTarget(window.App.prefixedUrl(`/sites/${this.siteNum}/devices/${this.devNum}/configs/new`), this.configTarget)
      .then(() => {
        this.hideNewLink();
      });
  }

  highlightRow(index) {
    this.clearConfig();
    let rowTarget = this.configRowTargets[index];
    if (!rowTarget.classList.contains("bg-indigo-100")) {
      rowTarget.classList.add("bg-indigo-100");
    }
  }

  removeAllRowHighlights() {
    for (const rowTarget of this.configRowTargets) {
      if (rowTarget.classList.contains("bg-indigo-100")) {
        rowTarget.classList.remove("bg-indigo-100");
      }
    }
  }

  cancelForm(event) {
    super.cancelForm(event);
    this.clearConfig();
  }

  clearConfig() {
    this.clearMessage();
    this.removeAllRowHighlights();
    this.showNewLink();
    this.configTarget.innerHTML = "";
  }
}
